/**
 * Features Section
 * Использует переиспользуемые компоненты
 */
import { Text, Icon, Container } from '../components';

const styleClasses = {
  cards: {
    item: 'bg-card border border-border rounded-xl p-5 md:p-6 hover:shadow-lg transition-shadow',
    icon: 'w-10 h-10 md:w-12 md:h-12 bg-primary/10 text-primary rounded-lg flex items-center justify-center mb-3 md:mb-4',
    titleSize: 'lg',
  },
  minimal: {
    item: 'text-center',
    icon: 'w-14 h-14 md:w-16 md:h-16 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4',
    titleSize: 'xl',
  },
  'icons-left': {
    item: 'flex gap-3 md:gap-4',
    icon: 'w-10 h-10 md:w-12 md:h-12 bg-primary/10 text-primary rounded-lg flex items-center justify-center flex-shrink-0',
    titleSize: 'lg',
  },
};

const gridClasses = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 md:grid-cols-2',
  3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
  4: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
};

export default function FeaturesSection({ data, styles }) {
  const columns = data?.columns || 3;
  const items = data?.items || [];
  const sectionStyle = data?.style || 'cards';
  const styleConfig = styleClasses[sectionStyle] || styleClasses.cards;

  return (
    <section
      style={{
        paddingTop: styles?.paddingTop || 64,
        paddingBottom: styles?.paddingBottom || 64,
        backgroundColor: styles?.backgroundColor || '#FFFFFF'
      }}
    >
      <Container>
        {/* Заголовок */}
        <Text
          as="h2"
          data={typeof data?.title === 'object' ? data.title : { text: data?.title }}
          defaults={{ size: '3xl', weight: 'bold', color: 'foreground' }}
          align="center"
          className={data?.subtitle ? 'mb-2' : 'mb-8 md:mb-10'}
        />

        {/* Подзаголовок */}
        <Text
          as="p"
          data={typeof data?.subtitle === 'object' ? data.subtitle : { text: data?.subtitle }}
          defaults={{ size: 'lg', weight: 'normal', color: 'text-secondary' }}
          align="center"
          className="mb-8 md:mb-10"
        />

        {items.length > 0 ? (
          <div className={`grid gap-4 md:gap-6 ${gridClasses[columns] || gridClasses[3]}`}>
            {items.map((item, index) => (
              <div key={item.id || index} className={styleConfig.item}>
                <div className={styleConfig.icon}>
                  <Icon name={item.icon || 'Star'} size="lg" />
                </div>
                <div className={sectionStyle === 'icons-left' ? 'flex-1' : ''}>
                  <Text
                    as="h3"
                    data={typeof item.title === 'object' ? item.title : { text: item.title }}
                    defaults={{ size: styleConfig.titleSize, weight: 'semibold', color: 'foreground' }}
                    className="mb-1.5 md:mb-2"
                  />
                  <Text
                    as="p"
                    data={typeof item.description === 'object' ? item.description : { text: item.description }}
                    defaults={{ size: 'sm', weight: 'normal', color: 'text-secondary' }}
                    className="leading-relaxed"
                  />
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 text-text-secondary">
            <Icon name="Plus" size="3xl" className="mx-auto mb-4 opacity-50" />
            <p>Добавьте преимущества в настройках</p>
          </div>
        )}
      </Container>
    </section>
  );
}
